import { useDispatch } from 'react-redux';
import { Box, Button, Fade, Paper, Stack, Typography, Popper } from '@mui/material';
import Colors from '../../../constants/colors';
import { trackEvent } from '../../../actions/segment';
import { createMixpanelProperties } from '../../../helpers/Segment';
import Segment from 'js/constants/segment';
import { links } from 'js/constants/corporateUrls';

const PlezzelDialogue = (props) => {
    const dispatch = useDispatch();
    const onButtonClick = () => {
        dispatch(trackEvent(createMixpanelProperties(Segment.EVENT_NAMES.LAUNCH_PLEZZEL, {
            page: Segment.EVENT_PROPERTIES.PROPERTY_DETAIL,
        })));
        window.open(links.plezzelPdp, '_blank');
    };
    return (
        <Popper
            open={props.open}
            anchorEl={props.anchorEl}
            transition
            disablePortal
            placement="bottom-end"
            sx={{
                zIndex: 3,
            }}
        >
            {({ TransitionProps }) => (
                <Fade {...TransitionProps} timeout={350}>
                    <Paper
                        sx={{
                            borderRadius: '4px',
                            p: 1,
                            mt: 1,
                            width: 350,
                            marginTop: 1,
                            marginBottom: 1,
                            textWrap: 'wrap',
                        }}
                    >
                        <Box p={1}>
                            <Stack gap={1}>
                                <Stack>
                                    <Typography
                                        sx={{
                                            color: Colors.BLACK_80_OPAQUE,
                                            fontWeight: 700,
                                            fontSize: '14px'
                                        }}
                                        variant="subtitle1"
                                    >
                                        Grow your brand with Digital Ads
                                    </Typography>
                                    <Typography
                                        sx={{
                                            color: Colors.BLACK_80_OPAQUE,
                                            fontSize: '14px',
                                        }}
                                        variant="subtitle1"
                                    >
                                        Acquire more leads and website traffic through targeted digital advertising.
                                    </Typography>
                                </Stack>
                                <Stack alignItems="flex-end">
                                    <Button
                                        variant="contained"
                                        sx={{
                                            backgroundColor: Colors.PRIMARY.MAIN,
                                            fontSize: '13px',
                                            fontWeight: '400',
                                            letterSpacing: '0.46px',
                                        }}
                                        onClick={onButtonClick}
                                    >
                                        Learn More
                                    </Button>
                                </Stack>
                            </Stack>
                        </Box>
                    </Paper>
                </Fade>
            )}
        </Popper>
    );
};

export default PlezzelDialogue;